import React, {Component} from 'react';
import Global from '../../Global';
import Slider from 'rc-slider';
import PhoneListHelper from './PhoneListHelper/PhoneListHelper';
import PhoneListMobileHelper from './PhoneListHelper/PhoneListMobileHelper';
import './PhoneList.css';
import hideLogo from "../../images/ichat/icon-down.png";
import checkedBox from "../../images/boxChecked.jpg";
import uncheckedBox from "../../images/boxUnchecked.jpg"
import noResult from "../../images/no-result.jpg"

const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Range = createSliderWithTooltip(Slider.Range);

export default class PhoneList extends Component {
    constructor(props) {
        super(props);
        this.btnBasicClass = "col-xs-4 col-sm-3 col-md-3 text-center filterBigBtnCommon ";
        this.btnNormalClass = this.btnBasicClass + "filterBigBtn";
        this.btnSelectedClass = this.btnBasicClass + "filterBigBtnSelected";
        this.btnAppliedClass = this.btnBasicClass + "filterBigBtnApplied";
        //this.checkedBox = require("../../images/boxChecked.jpg");
        //this.uncheckedBox = require("../../images/boxUnchecked.jpg");

        console.log("isDefaultFiveG=" + this.props.isDefaultFiveG);

        this.state = {
            generalLabels: {},
            phoneList: [],
            mobilePhoneList: [],
            brandOptions: [{value: "", brand: "Any", isSelected: true}],
            sizeOptions: [{label: "0GB", size: 0, isSelected: true}],
            priceOptions: [],
            fiveGSelected: false,
            selectedBrand: "",
            selectedSize: "0",
            selectedPrice: "",
            brandBtnText: "",
            sizeBtnText: "",
            priceBtnText: "",
            generationBtnText: "",
            generationImage: "",
            brandDialogStyle: {display: "none"},
            sizeDialogStyle: {display: "none"},
            priceDialogStyle: {display: "none"},
            brandBtnClass: this.btnNormalClass,
            sizeBtnClass: this.btnNormalClass,
            fiveGBtnClass: this.btnNormalClass,
            priceBtnClass: this.btnNormalClass,
            viewMultiplier: 9,
            //Note that displayPhone only means max no. of phone displayed
            displayPhone: 9,
            displayedPriceRange: [0, 500],
            priceRange: [0, 500],
            showAllBtnStyle: {display: "none"},
            mainBlockStyle: {display: "block"},
            alertBlockStyle: {display: "none"},
            //Check retail price status
            allNotContainRetailPrice: false
        }
    }

    componentDidMount = async() => {
        let url = Global.getAPI('phone-detail');
        try{
            let response = await fetch(url);
            if(response.status >= 400) throw new Error("Error API: phone-detail");
            let responseJson = await response.json();
            let generalLabels = responseJson.generalLabels;
            let generalData = responseJson.generalDatas;
            let phoneJson = responseJson.phoneDetailList;

            let generalPriceRange = [parseInt(generalData.minContractPrice), parseInt(generalData.maxContractPrice)];

            let phoneList = [];
            let mobilePhoneList = [];

            let hasRetailCount = 0;

            phoneJson.forEach(o => {
                let pushObj = {
                    name: o.modelName,
                    brand: o.brand,
                    networkTag: o.networkTag,
                    capacity: "0GB",
                    capacityCollection: ["0GB"],
                    integerCap: 0,
                    integerCapCollection: [0],
                    img: o.thumbIMGPath,
                    routingLink: o.landingPageLink,
                    subscriptionLink: o.subscriptionLink,
                    retailLink: o.retailLink,
                    isNew: o.isNew==="true" ? generalLabels.newTag : "",
                    isHotPick: o.isHotPick==="true" ? generalLabels.hotpickTag : "",
                    cellularGen: o.networkTag,
                    sPlanLabel: generalLabels.subsTitle,
                    sPlanPrice: o.contractPrice,
                    sPlanUp: generalLabels.upTag,
                    enjoyInfo: o.contractMsg.replace(/�/g, " "),
                    orTag: generalLabels.orTag,
                    rPriceLabel: generalLabels.retailTitle,
                    rPrice: o.retailPrice,
                    rPriceUp: generalLabels.upTag,
                    exclusiveLabel: o.retailMsg,
                    isInShortlist: true
                };

                if(o.romCapacities.length > 0){
                    let capacityCollection = [];
                    let integerCapCollection = [];
                    o.romCapacities.forEach(x => {
                        //let clonedObj = {...pushObj}
                        //clonedObj.capacity = x;
                        //clonedObj.integerCap = this.evaluateSize(x);
                        capacityCollection.push(x.replace(/\s/g, ""));
                        integerCapCollection.push(this.evaluateSize(x.replace(/\s/g, "")))

                        pushObj.capacityCollection = capacityCollection;
                        pushObj.integerCapCollection = integerCapCollection;

                        //phoneList.push(clonedObj);
                    })
                    phoneList.push(pushObj);
                }
                else{
                    phoneList.push(pushObj);
                }

                if(o.retailPrice.trim() !== ""){
                    hasRetailCount++;
                }
            });

            let sizeMap = new Map();
            let sizeList = [{label: generalLabels.anySize, size: 0, isSelected: true}];
            let brandMap = new Map();
            let brandList = [{value: "", brand: generalLabels.anyBrand, isSelected: true}];

            let initViewCount = parseInt(this.state.viewMultiplier);

            phoneList.forEach((o, i) => {
                //Params
                let deviceName = o.name;
                let deviceCapacity = o.capacity.replace(/\s/g, "");

                //In case name have GB
                /*
                if(deviceName.includes("GB") || deviceName.includes("TB")){
                    let lastIndex = deviceName.lastIndexOf(" ");
                    deviceCapacity = deviceName.substring(lastIndex + 1, deviceName.length).replace(/\s/g, "");
                    deviceName = deviceName.substring(0, lastIndex);

                    o.name = deviceName;
                    //o.capacity = deviceCapacity;
                    //o.integerCap = this.evaluateSize(deviceCapacity);
                    o.capacityCollection = [deviceCapacity];
                    o.integerCapCollection = [this.evaluateSize(deviceCapacity)];
                    //console.log("|"+deviceCapacity+"|");
                }
                 */

                for(let i=0; i<o.capacityCollection.length; i++){
                    let sizeLabel = o.capacityCollection[i];
                    if(!sizeMap.has(sizeLabel)){
                        if(this.evaluateSize(sizeLabel)!==0) {
                            sizeMap.set(sizeLabel, 1);
                            sizeList.push({label: sizeLabel, size: this.evaluateSize(sizeLabel), isSelected: true});
                        }
                    }
                }

                //Deduplicate Brand
                if(!brandMap.has(o.brand)){
                    brandMap.set(o.brand, 1);
                    brandList.push({value: o.brand, brand: o.brand, isSelected: true})
                }
                //Init Class and Style
                phoneList[i].className = "phoneItem col-12 col-xs-12 col-sm-6 col-md-4 col-lg-4";
                let genTag = "threeGTag";
                if(o.cellularGen === "5G")
                    genTag = "fiveGTag";
                else if(o.cellularGen === "4G LTE")
                    genTag = "lteTag";
                phoneList[i].geneClass = "text-center " + genTag;
                phoneList[i].bgStyle = {backgroundImage:'url(' + encodeURI(o.img) + ')'};
                mobilePhoneList.push({...phoneList[i]});
                phoneList[i].style = {display: (i < initViewCount) ? "block" : "none"};
            });



            //Sort Capacity List, ascending order
            sizeList = await sizeList.sort((x, y) => {return x.size - y.size});

            /*
            let additionalLabel = sizeList[sizeList.length-1].label;
            if(sizeList[sizeList.length-1].size < 1024){
                additionalLabel = (sizeList[sizeList.length-1].size + 1).toString() + "GB";
            }

            sizeList.push({
                label: additionalLabel + " " + generalLabels.upTag,
                size: sizeList[sizeList.length-1].size + 1,
                isSelected: true
            });

             */

            //Sort Brand List, ascending order
            brandList = await brandList.sort((x, y) => {
                return (x.value===y.value) ? 0 : ((x.value > y.value) ? 1 : -1)
            });

            await this.setState({
                generalLabels: generalLabels, phoneList: phoneList,
                mobilePhoneList: mobilePhoneList,
                brandOptions: brandList, sizeOptions: sizeList,
                showAllBtnStyle: {display: (phoneList.length > initViewCount) ? "block" : "none"},
                brandBtnText: generalLabels.compareByBrand,
                sizeBtnText: generalLabels.compareBySize,
                priceBtnText: generalLabels.compareByPrice,
                generationBtnText: generalLabels.compareByGeneration,
                generationImage: generalLabels.generationImage,
                priceRange: generalPriceRange,
                displayedPriceRange: generalPriceRange,
                allNotContainRetailPrice: (hasRetailCount === 0)
            }, () => {
                if(this.props.isDefaultFiveG == true){
                    this.clickGeneration();
                }
            });
        }
        catch(e){
            console.error(e);
        }
    }

    evaluateSize = (x) => {
        let baseUnit = x.includes("GB") ? "GB" : "TB";
        return parseInt(x.replace(baseUnit, "")) * ((baseUnit === "TB") ? 1024 : 1)
    }

    mobileHidePopup = () => {
        let brandBtnClass = this.btnNormalClass;
        let brandDialogStyle = {display: "none"};
        let sizeBtnClass = this.btnNormalClass;
        let sizeDialogStyle = {display: "none"};
        let priceBtnClass = this.btnNormalClass;
        let priceDialogStyle = {display: "none"};

        this.setState({
            brandBtnClass: brandBtnClass,
            brandDialogStyle: brandDialogStyle,
            sizeBtnClass: sizeBtnClass,
            sizeDialogStyle: sizeDialogStyle,
            priceBtnClass: priceBtnClass,
            priceDialogStyle: priceDialogStyle
        });
    }

    popupFilter = (s) => {
        let brandBtnClass = this.btnNormalClass;
        let brandDialogStyle = {display: "none"};
        let sizeBtnClass = this.btnNormalClass;
        let sizeDialogStyle = {display: "none"};
        let priceBtnClass = this.btnNormalClass;
        let priceDialogStyle = {display: "none"};
        if(s==="brand"){
            //Itself
            brandBtnClass = (this.state.brandDialogStyle.display ==="none") ? this.btnSelectedClass : ((this.state.brandBtnText.includes("(")) ? this.btnAppliedClass : this.btnNormalClass);
            brandDialogStyle = {display: (this.state.brandDialogStyle.display ==="none") ? "block" : "none"};
            //Other
            sizeBtnClass = (this.state.sizeBtnClass === this.btnAppliedClass) ? this.btnAppliedClass : this.btnNormalClass;
            priceBtnClass = (this.state.priceBtnClass === this.btnAppliedClass) ? this.btnAppliedClass : this.btnNormalClass;
        }
        else if(s==="size"){
            //Itself
            sizeBtnClass = (this.state.sizeDialogStyle.display ==="none") ? this.btnSelectedClass : ((this.state.sizeBtnText.includes("(")) ? this.btnAppliedClass : this.btnNormalClass);
            sizeDialogStyle = {display: (this.state.sizeDialogStyle.display ==="none") ? "block" : "none"};
            //Other
            brandBtnClass = (this.state.brandBtnClass === this.btnAppliedClass) ? this.btnAppliedClass : this.btnNormalClass;
            priceBtnClass = (this.state.priceBtnClass === this.btnAppliedClass) ? this.btnAppliedClass : this.btnNormalClass;
        }
        else if(s==="price"){
            //Itself
            priceBtnClass = (this.state.priceDialogStyle.display ==="none") ? this.btnSelectedClass : (priceBtnClass = (this.state.priceBtnText.includes("$")) ? this.btnAppliedClass : this.btnNormalClass);
            priceDialogStyle = {display: (this.state.priceDialogStyle.display ==="none") ? "block" : "none"};
            //Other
            brandBtnClass = (this.state.brandBtnClass === this.btnAppliedClass) ? this.btnAppliedClass : this.btnNormalClass;
            sizeBtnClass = (this.state.sizeBtnClass === this.btnAppliedClass) ? this.btnAppliedClass : this.btnNormalClass;
        }

        this.setState({
            brandBtnClass: brandBtnClass,
            brandDialogStyle: brandDialogStyle,
            sizeBtnClass: sizeBtnClass,
            sizeDialogStyle: sizeDialogStyle,
            priceBtnClass: priceBtnClass,
            priceDialogStyle: priceDialogStyle
        });
    }

    clickBrand = (i) => {
        let brandList = this.state.brandOptions;
        let prevSelected = brandList[i].isSelected;
        brandList[i].isSelected = !prevSelected;
        if(i>0){
            let elseSelectedCount = 0;
            for(let x=1; x<brandList.length; x++)
                elseSelectedCount+= brandList[x].isSelected ? 1 : 0;

            brandList[0].isSelected = elseSelectedCount===(brandList.length - 1) ? true : false;
        }
        else{
            for(let x=1; x<brandList.length; x++)
                brandList[x].isSelected = brandList[0].isSelected
        }
        this.setState({brandOptions: brandList})
    }

    clickSize = (i) => {
        let sizeList = this.state.sizeOptions;
        let prevSelected = sizeList[i].isSelected;
        sizeList[i].isSelected = !prevSelected;
        if(i>0){
            let elseSelectedCount = 0;
            for(let x=1; x<sizeList.length; x++)
                elseSelectedCount+= sizeList[x].isSelected ? 1 : 0;

            sizeList[0].isSelected = elseSelectedCount===(sizeList.length - 1) ? true : false;
        }
        else{
            for(let x=1; x<sizeList.length; x++)
                sizeList[x].isSelected = sizeList[0].isSelected
        }
        this.setState({sizeOptions: sizeList})
    }

    resetFilter = () => {
        let brandList = this.state.brandOptions;
        let sizeList = this.state.sizeOptions;
        let priceRange = this.state.displayedPriceRange;

        brandList.forEach((o, i) => {brandList[i].isSelected = true;});
        sizeList.forEach((o, i) => {sizeList[i].isSelected = true;});

        this.setState({
            brandOptions: brandList,
            sizeOptions: sizeList,
            priceRange: priceRange
        }, () => this.filterPhone())
    }

    changeFilterRange(range) {
        this.setState({priceRange: range}, () => {return true});
    }

    clickGeneration = () => {
        let currentStatus = this.state.fiveGSelected;
        let nextStatus = !currentStatus;
        let generationBtnClass = (nextStatus === true) ? this.btnAppliedClass : this.btnNormalClass;
        this.setState({fiveGSelected: nextStatus, fiveGBtnClass: generationBtnClass}, () => {this.filterPhone()});
    }

    showMore = () => {
        let phoneList = this.state.phoneList;
        let initViewCount = parseInt(this.state.viewMultiplier);
        let updatedViewCount = parseInt(this.state.displayPhone) + initViewCount;
        let isInShortListCount = 0;

        phoneList.forEach((o, i) => {
            if(o.isInShortlist === true){
                isInShortListCount++;
                if(isInShortListCount <= updatedViewCount){
                    phoneList[i].style = {display: "block"};
                }
            }
        })

        this.setState({
            phoneList: phoneList,
            showAllBtnStyle: {display: (updatedViewCount >= isInShortListCount) ? "none" : "block"},
            displayPhone: updatedViewCount
        })
    }

    filterPhone = () => {
        let brandList = this.state.brandOptions;
        let sizeList = this.state.sizeOptions;
        let phoneList = this.state.phoneList;
        let priceRange = this.state.priceRange;
        let mobilePhoneList = [];

        let initViewCount = this.state.viewMultiplier;
        let shortlistedCount = 0;

        let brandBtnText = this.state.generalLabels.compareByBrand;
        let sizeBtnText = this.state.generalLabels.compareBySize;
        let priceBtnText = this.state.generalLabels.compareByPrice;

        let selectedBrand = 0;
        let selectedSize = 0;

        let brandBtnClass = this.btnNormalClass;
        let sizeBtnClass = this.btnNormalClass;
        let priceBtnClass = this.btnNormalClass;

        if(brandList[0].isSelected!==true){
            for(let x=1; x<brandList.length; x++){
                selectedBrand+=(brandList[x].isSelected===true) ? 1 : 0
            }
            brandBtnText = brandBtnText + " (" + selectedBrand + ")"
            brandBtnClass = this.btnAppliedClass
        }

        if(sizeList[0].isSelected!==true){
            for(let x=1; x<sizeList.length; x++){
                selectedSize+=(sizeList[x].isSelected===true) ? 1 : 0
            }
            sizeBtnText = sizeBtnText + " (" + selectedSize + ")"
            sizeBtnClass = this.btnAppliedClass
        }

        if(priceRange[0]!==this.state.displayedPriceRange[0] || priceRange[1]!==this.state.displayedPriceRange[1]){
            priceBtnText = "$"+priceRange[0]+ " - "+"$"+priceRange[1];
            priceBtnClass = this.btnAppliedClass
        }

        phoneList.forEach((o, i) => {
            //1st: Brand
            let forBrand = false;
            if(brandList[0].isSelected===true)
                forBrand = true;
            else{
                let selectedBrandList = [];
                for(let x=1; x<brandList.length; x++){
                    if(brandList[x].isSelected===true){
                        selectedBrandList.push(brandList[x].brand);
                        forBrand = (selectedBrandList.indexOf(o.brand) > -1) ? true : false;
                    }
                }
            }

            //1.5: For Gen
            let forGen = false;
            if(this.state.fiveGSelected == false){
                forGen = true;
            }
            else{
                forGen = o.networkTag === "5G";
            }

            //2nd: Size
            let forSize = false;
            if(sizeList[0].isSelected===true)
                forSize = true;
            else{
                for(let x=1; x<sizeList.length-1 && forSize===false; x++){
                    if(sizeList[x].isSelected===true){
                        forSize = (o.integerCapCollection.indexOf(sizeList[x].size) > -1) ? true : false;
                        //forSize = (o.integerCap===sizeList[x].size) ? true : false;
                    }
                }
                if(sizeList[sizeList.length-1].isSelected===true && forSize===false){
                    let deviceMaxSize = o.integerCapCollection[o.integerCapCollection.size - 1];
                    forSize = (deviceMaxSize >= sizeList[sizeList.length-1].size) ? true : false;
                    //forSize = (o.integerCap >= sizeList[sizeList.length-1].size) ? true : false;
                }
            }
            //3rd: Price Filter
            let price = 0;
            if(o.sPlanPrice !== ""){
                price = parseInt(o.sPlanPrice.replace("$", ""));
            }
            let forPrice = (price >= priceRange[0] && price <= priceRange[1]) ? true : false;
            if(o.sPlanPrice === ""){
                if(priceRange[0] === this.state.displayedPriceRange[0] && priceRange[1] === this.state.displayedPriceRange[1]){
                    forPrice = true;
                }
                else{
                    forPrice = false;
                }
            }
            //Overall Decision
            let isInShortlist = (forBrand === true && forGen === true && forSize === true && forPrice === true) ? true : false;
            shortlistedCount+=(isInShortlist === true) ? 1 : 0;
            phoneList[i].isInShortlist = isInShortlist;
            phoneList[i].style = {display: (isInShortlist === true && shortlistedCount <= initViewCount) ? "block" : "none"};

            if(isInShortlist === true){
                let clonedObj = {...phoneList[i]};
                clonedObj.style = {};
                mobilePhoneList.push(clonedObj)
            }
        });

        let mainBlockStyle = {display: (shortlistedCount > 0) ? "block" : "none"};
        let alertBlockStyle = {display: (shortlistedCount > 0) ? "none" : "block"};

        this.setState({
            phoneList: phoneList,
            mobilePhoneList: mobilePhoneList,
            displayPhone: initViewCount,
            brandDialogStyle: {display: "none"},
            sizeDialogStyle: {display: "none"},
            priceDialogStyle: {display: "none"},
            showAllBtnStyle: {display: (shortlistedCount > initViewCount) ? "block" : "none"},
            brandBtnText: brandBtnText, sizeBtnText: sizeBtnText, priceBtnText: priceBtnText,
            brandBtnClass: brandBtnClass, sizeBtnClass: sizeBtnClass, priceBtnClass: priceBtnClass,
            mainBlockStyle: mainBlockStyle,
            alertBlockStyle: alertBlockStyle
        })
    }

    render(){
        let SelectableItems = (props) => {
            return(
                <div className="selectableItems col-xs-6 col-sm-6 col-md-12 col-lg-12" onClick={props.onClick}>
                    <div className="row">
                        <div className="col-2 col-xs-2 selectableChb text-center">
                            <img src={props.selected ? checkedBox : uncheckedBox}/>
                        </div>
                        <div className="col-10 col-xs-10 checkboxText"> {props.label}</div>
                    </div>
                </div>
            )
        }

        let FilterPulldownBtn = (props) => {
            return(<div className={props.className} onClick={props.onClick}>{props.label}</div>);
        }

        let FilterPulldownPop = (props) => {
            return(
                <div key={props.className} className={props.className} style={props.dialogStyle}>
                    <img className="hideBtn" onClick={()=> this.mobileHidePopup()} src={hideLogo}/>
                    <div className="preGap"/>
                    {props.listRender}
                    <div className="col-12 col-xs-12" style={{height: 10}}/>
                    <div>
                        <div className="col-2 col-xs-2"/>
                        <div onClick={props.applyAction} className="col-8 col-xs-8 text-center submitBtn">
                            {props.applyTag}
                        </div>
                        <div className="col-2 col-xs-2"/>
                    </div>
                    <div className="col-12 col-xs-12" style={{height: 10}}/>
                </div>
            )
        }

        let FilterSliderPop = (props) => {
            return(
                <div className={props.className} style={props.dialogStyle}>
                    <img className="hideBtn" onClick={()=> this.mobileHidePopup()} src={hideLogo}/>
                    <div className="preGap"/>
                    <div className="col-12 col-xs-12 text-center">
                        <div className="row" style={{paddingBottom: 5, paddingTop: 10}}>
                            <div className="col-6 col-xs-6" style={{textAlign: "left"}}>${props.displayedPriceRange[0]}</div>
                            <div className="col-6 col-xs-6" style={{textAlign: "right"}}>${props.displayedPriceRange[1]}</div>
                        </div>
                        <div className={"priceBar"}>
                            <Range min={props.displayedPriceRange[0]} max={props.displayedPriceRange[1]} defaultValue={props.priceRange} allowCross={false} onAfterChange={(value) => this.changeFilterRange(value)} tipFormatter={value => "$" + value}/>
                        </div>
                    </div>
                    <div className="col-12 col-xs-12" style={{height: 10}}/>
                    <div>
                        <div className="col-2 col-xs-2"/>
                        <div onClick={props.applyAction} className="col-8 col-xs-8 text-center submitBtn">
                            {props.applyTag}
                        </div>
                        <div className="col-2 col-xs-2"/>
                    </div>
                    <div className="col-12 col-xs-12" style={{height: 10}}/>
                </div>
            )
        }

        let TopBlock = (props) =>{
            let sizeList = this.state.sizeOptions;
            let sizeRender = sizeList.map((o, i) => {
                return(
                    <SelectableItems label={o.label} selected={o.isSelected} onClick={() => this.clickSize(i)} />
                );
            });

            let brandList = this.state.brandOptions;
            let brandRender = brandList.map((o, i) => {
                return(
                    <SelectableItems label={o.brand} selected={o.isSelected} onClick={() => this.clickBrand(i)} />
                );
            });

            return(
                <div className="row phone-list-title">
                    <div className="titleWrapper col-12 col-xs-12 col-md-6">
                        <h3>{this.state.generalLabels.topTitle}</h3>
                    </div>
                    <div className="col-12 col-xs-12 col-md-6" style={{padding: 0}}>
                        <FilterPulldownBtn className={this.state.fiveGBtnClass} label={this.state.generationBtnText} onClick={() => this.clickGeneration()}/>
                        <FilterPulldownBtn className={this.state.brandBtnClass} label={this.state.brandBtnText} onClick={() => this.popupFilter("brand")}/>
                        <FilterPulldownBtn className={this.state.sizeBtnClass} label={this.state.sizeBtnText} onClick={() => this.popupFilter("size")}/>
                        <FilterPulldownBtn className={this.state.priceBtnClass} label={this.state.priceBtnText} onClick={() => this.popupFilter("price")}/>
                    </div>
                    <FilterPulldownPop className={"brandFilterContainer"} dialogStyle={this.state.brandDialogStyle}
                                       listRender={brandRender} applyAction={()=> this.filterPhone()} applyTag={this.state.generalLabels.applyTag}/>
                    <FilterPulldownPop className={"sizeFilterContainer"} dialogStyle={this.state.sizeDialogStyle}
                                       listRender={sizeRender} applyAction={()=> this.filterPhone()} applyTag={this.state.generalLabels.applyTag}/>
                    <FilterSliderPop className={"priceFilterContainer"} dialogStyle={this.state.priceDialogStyle}
                                     displayedPriceRange = {this.state.displayedPriceRange}
                                     priceRange={this.state.priceRange} applyAction={()=> this.filterPhone()} applyTag={this.state.generalLabels.applyTag}/>
                </div>
            )
        };

        return(
            <div className="phoneList container">
                <TopBlock />
                <div className={"row phoneListMainBlock"} style={this.state.mainBlockStyle}>
                    <PhoneListHelper phoneList={this.state.phoneList} allNotRetail={this.state.allNotContainRetailPrice} fiveGLabel={this.state.generalLabels.generationImage}/>
                    <PhoneListMobileHelper phoneList={this.state.mobilePhoneList} allNotRetail={this.state.allNotContainRetailPrice} fiveGLabel={this.state.generalLabels.generationImage}/>
                    <div className="col-xs-12 showMoreBtnDiv" style={{height: 50}}/>
                    <div className="col-xs-12 showMoreBtnDiv">
                        <div className="col-xs-1 col-sm-4"/>
                        <div className="col-xs-10 col-sm-4 showMoreBtn" onClick={()=> this.showMore()} style={this.state.showAllBtnStyle}>
                            <div className="showMoreBtnInner">
                                {this.state.generalLabels.showMore}
                            </div>
                        </div>
                        <div className="col-xs-1 col-sm-4"/>
                    </div>
                    <div className="col-xs-12" style={{height: 50}}/>
                    <div className="col-xs-12">{this.state.generalLabels.notes}</div>
                </div>
                <div className={"phoneListAlertBlock"} style={this.state.alertBlockStyle}>
                    <div className="col-xs-12">
                        <div className="noResultGap col-xs-1 col-sm-4"/>
                        <div className="col-xs-10 col-sm-4 text-center">
                            <img className="noResultImg" src={noResult}/>
                        </div>
                        <div className="noResultGap col-xs-1 col-sm-4"/>
                    </div>
                    <div className="col-xs-12" style={{height: 20}}/>
                    <div className="col-xs-12 text-center">
                        <h4>{this.state.generalLabels.alertMsg}</h4>
                    </div>
                    <div className="col-xs-12" style={{height: 30}}/>
                    <div className="col-xs-12 text-center">
                        <div className="col-xs-2 col-sm-3"/>
                        <div className="col-xs-8 col-sm-6 phoneListResetBtn" onClick={()=>this.resetFilter()}>
                            {this.state.generalLabels.resetBtn}
                        </div>
                        <div className="col-xs-2 col-sm-3"/>
                    </div>
                </div>
                <div className="col-xs-12" style={{height: 30}}/>
            </div>
        )
    }
}